import {NgModule, Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
	selector: 'column-view',
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [':host ::ng-deep row-container list:first-child{ margin-top: 0 !important}']
})
export class ColumnView {
    ngOnInit(){        
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/column-layout/column-view.component.ts